import React from 'react';

const HealthCheck = () => {
    return (
        <div>Health Check Page</div>
	);
};

export default HealthCheck;